'use client';

import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

import { ATTRIBUTION_COOKIE_NAME } from '@/features/common/config/attributionParams';

/**
 * Middleware가 서버에서 설정한 유입 경로 쿠키를 읽어오는 단순한 훅.
 * @returns {{attributionParams: URLSearchParams | null}}
 *          - attributionParams: 쿠키에서 읽어온 유입 경로 파라미터 객체.
 */
export function useAttribution() {
  const [attributionParams, setAttributionParams] = useState<URLSearchParams | null>(null);

  useEffect(() => {
    // This hook now ONLY reads the cookie set by the middleware.
    const cookieValue = Cookies.get(ATTRIBUTION_COOKIE_NAME);
    if (cookieValue) {
      try {
        const paramsFromCookie = JSON.parse(cookieValue);
        setAttributionParams(new URLSearchParams(paramsFromCookie));
      } catch (e) {
        console.error('Failed to parse attribution cookie:', e);
        setAttributionParams(new URLSearchParams());
      }
    } else {
      setAttributionParams(new URLSearchParams());
    }
  }, []); // Run only once on component mount

  return { attributionParams };
}
